"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _svg = _interopRequireDefault(require("./svg"));

require("./slide-in-panel.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SlideInPanel = function SlideInPanel(_ref) {
  var isVisible = _ref.isVisible,
      onCloseClick = _ref.onCloseClick,
      headerText = _ref.headerText,
      children = _ref.children;

  if (BROWSER && document && document.body) {
    document.body.classList.toggle('modal', isVisible);
  }

  var blockUi = isVisible ? /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "clearButton block-ui backdrop",
    onClick: onCloseClick
  }) : null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "SlideInPanel"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('wrapper', {
      visible: isVisible
    })
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "header"
  }, headerText, /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    className: "closeButton",
    id: "close",
    onClick: onCloseClick
  })), children), blockUi);
};

SlideInPanel.propTypes = {
  onCloseClick: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].node.isRequired,
  isVisible: _propTypes["default"].bool,
  headerText: _propTypes["default"].string
};
SlideInPanel.defaultProps = {
  isVisible: false,
  headerText: ''
};
var _default = SlideInPanel;
exports["default"] = _default;